var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-socialResponsibility"},[_c('div',{staticClass:"about-socialResponsibility-title"},[_vm._v("社会责任")]),_vm._v(" "),_c('div',{staticClass:"about-socialResponsibility-content"},_vm._l((_vm.data),function(item,index){return _c('TimeAxios',{key:("timeAxis-item" + (index + 1)),attrs:{"data":item}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02cd16e9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/about/socialResponsibility.vue
// module id = null
// module chunks = 